import React from 'react';
import { Minus, TrendingDown, TrendingUp } from 'lucide-react';

// Shared trend pill. Renders nothing for null deltas (silent), so callers
// don't need to wrap with a conditional. Direction colors match the rest of
// the reporting module (green = up, red = down, neutral = flat).
//
// `betterIsUp` flips the color logic for metrics where lower is better
// (e.g. MTTR — lower repair time is good, so a negative delta is green).

const COLORS = {
  good: '#10b981',
  bad: '#ef4444',
  neutral: '#6b7280',
};

export default function DeltaIndicator({ delta, betterIsUp = true }) {
  if (delta == null || Number.isNaN(delta)) return null;
  const positive = delta > 0;
  const negative = delta < 0;
  const Icon = positive ? TrendingUp : negative ? TrendingDown : Minus;
  const isGood = positive ? betterIsUp : negative ? !betterIsUp : null;
  const color = isGood == null ? COLORS.neutral : isGood ? COLORS.good : COLORS.bad;
  const sign = positive ? '+' : '';

  return (
    <span
      className="d-inline-flex align-items-center gap-1 font-size-12 fw-semibold"
      style={{ color }}
    >
      <Icon size={14} />
      {sign}{Math.abs(delta).toFixed(2)}%
    </span>
  );
}
